import { Row, Table } from '@tanstack/react-table';
import { FilterFn } from '@tanstack/react-table';
import { GTInternalIds } from './types';
import _ from 'lodash';

declare module '@tanstack/react-table' {
  interface FilterFns {
    textSearch: FilterFn<unknown>;
  }
}

type TextFilterFn = (
  row: Row<Record<string, unknown>>,
  columnId: string,
  value: string,
  addMeta: Function,
  searchable?: true | string[],
) => boolean;

export const textFilter: TextFilterFn = (row, columnId, value, _addMeta, searchable) => {
  if (!value || value === '') {
    return true;
  }

  const searchLower = String(value).toLowerCase();

  if (searchable === true) {
    const cellValue = row.getValue(columnId);
    return cellValue != null && String(cellValue).toLowerCase().includes(searchLower);
  }

  if (Array.isArray(searchable)) {
    for (const key of searchable) {
      const fieldValue = row.getValue(key) ?? row.original[key];
      if (fieldValue != null && String(fieldValue).toLowerCase().includes(searchLower)) {
        return true;
      }
    }
    return false;
  }

  const cellValue = row.getValue(columnId);
  return cellValue != null && String(cellValue).toLowerCase().includes(searchLower);
};

export const getClassNameByHeaderId = (headerId: string) => {
  switch (headerId) {
    case GTInternalIds.tdm:
      return 'gt-align-right';
    case GTInternalIds.expander:
      return 'gt-align-left';
    case GTInternalIds.checker:
      return 'gt-align-left';
    default:
      return '';
  }
};

type GTCheckHandler = <T = string>(
  params: { table: Table<any>; selector: string | string[]; checked: T[] },
  cb: (checked: T[]) => void,
) => { checkAllHandler: () => void; isAllChecked: boolean; visibleRows: T[] };

export const gTCheckHandler: GTCheckHandler = ({ table, selector, checked }, setChecked) => {
  const visibleRows = table.getRowModel().rows.map((el) => {
    if (typeof selector === 'string') {
      return el.original[selector];
    } else if (Array.isArray(selector)) {
      const index = selector.findIndex((key) => Boolean(el.original[key]));
      return index >= 0 ? el.original[selector[index]] : el.original[selector[0]];
    }
    return null;
  });

  const isAllChecked = _.every(visibleRows, (element) => _.includes(checked, element));

  const checkAllHandler = () => {
    if (isAllChecked) {
      setChecked(_.difference(checked, visibleRows));
    } else {
      const ids = _.uniq([...checked, ...visibleRows]);
      setChecked(ids);
    }
  };

  return { checkAllHandler, isAllChecked, visibleRows };
};
